export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deposit-bonus.vue?vue&type=template&id=84c9ae94"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/deposit-bonus.vue?vue&type=template&id=84c9ae94
// module id = 7+1g
// module chunks = 0